import { httpGet, httpPost, httpPut, httpPatch } from "@/request/http";

let path = "/lingyueh";

export default {
  postConnectionTest(dTO) {
    return httpPost(`${path}/connectionTest`, dTO);
  }
};
